import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaProperty.vue.script.js";
/* empty css                             */
//#region src/schema/SchemaProperty.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-071aaa62"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaProperty.vue.js.map